/**
 * Acceptable values as storage types for use in {@link StorageService}.
 *
 * _This constant should not be exposed by the bundle._
 *
 * @type {Object}
 * @property {string[]} STORAGE_TYPES.IN_MEMORY valid strings for **memory storage** type
 * @property {string[]} STORAGE_TYPES.LOCAL_STORAGE valid strings for **local storage** type
 * @property {string[]} STORAGE_TYPES.SESSION_STORAGE valid strings for **session storage** type
 */
const STORAGE_TYPES = {
    IN_MEMORY: ['in_memory', 'in-memory', 'memory', 'inmemory'],
    LOCAL_STORAGE: ['local_storage', 'local-storage', 'local', 'localstorage'],
    SESSION_STORAGE: ['session_storage', 'session-storage', 'session', 'sessionstorage'],
};

export default STORAGE_TYPES;
